import React from 'react';
import { BrowserRouter as Router, Switch , Route} from 'react-router-dom';
import AuthState from './context/authContext/authState';
import CartaState from './context/cartaContext/cartaState';
import AdminState from './context/adminContext/adminState'
import { ThemeProvider } from '@material-ui/core/styles';
import {CssBaseline} from '@material-ui/core'
import tokenAuth from './config/tokenAuth';

//MATERIAL THEME
import theme from './themeConfig';

//COMPONENTS
import Facturacion from './components/admin/Facturacion'
import Carta from './components/publica/Carta'
import Login from './components/auth/Login';
// import SignUp from './components/auth/SignUp';
import Cliente from './components/cliente/Cliente';
// import Admin from './components/admin/Admin';
import RutaCliente from './components/HigherOrderComponents/RutaCliente';
import AddMenu from './components/admin/AddMenu';
import NewPedido from './components/admin/NewPedido';
import VerCarta from './components/admin/VerCarta';
import Salon from './components/admin/Salon';
import NewSalon from './components/admin/NewSalon';
import AddSalon from './components/admin/AddSalon';


//VERIFICAR SI HAY TOKEN 
const token = localStorage.getItem('token');
if(token){
  tokenAuth(token) 
}

function App() {
 
  return (
    <>
    <CssBaseline/>  
    <AuthState>
      
      <CartaState>
        <ThemeProvider theme={theme}>
        <Router>
          <Switch>
            <Route exact path = '/' component={Login}/>
            {/* <Route exact path = '/signUp' component={SignUp}/> */}
            <Route exact path = '/carta' component={Carta}/>
            <RutaCliente exact path = '/client' component={Cliente}/>
            <AdminState>   
              {/* <RutaCliente exact path = '/admin' component={Admin}/> */}
              <RutaCliente exact path = '/admin/add_menu' component={AddMenu}/>
              <RutaCliente exact path = '/admin/new_pedido' component={NewPedido}/>
              <RutaCliente exact path = '/admin/ver_carta' component={VerCarta}/>
              <RutaCliente exact path = '/admin/salon' component={Salon}/>
              <RutaCliente exact path = '/admin/new_pedidoSalon' component={NewSalon}/>
              <RutaCliente exact path = '/admin/add_salon' component={AddSalon}/>
             
              <RutaCliente exact path = '/admin/facturacion' component={Facturacion}/>
            </AdminState>
       
          </Switch>
        </Router>
        </ThemeProvider>  
      </CartaState>
      
    </AuthState>
    </>
  );
}

export default App;
